"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, forwardRef, useContext, useLayoutEffect, useRef, useState, useTransition } from "react";
import { usePathname, useRouter } from "next/navigation";
import logo from "@/assets/images/logo.svg";
import { motion } from "motion/react";
import Image from "next/image";
import { Drawer } from "vaul";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useCurrentUser, useCurrentWorkspace } from "@/lib/auth/client";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { isAdmin, isSuperAdmin as isSuperAdminFn } from "@/lib/auth/roles";
import { useIssueType } from "@/components/issue/issue-type-provider";
import { WorkspaceSwitcher } from "./workspace-switcher";
import { Link } from "../ui/link";
import { Icon } from "../ui/icon";
export const Topbar = () => {
  const $ = _c(26);
  const workspace = useCurrentWorkspace();
  const user = useCurrentUser();
  const pathname = usePathname();
  const issueType = useIssueType();
  const t0 = `/${workspace?.slug}/projects`;
  let t1;
  if ($[0] !== issueType || $[1] !== pathname || $[2] !== workspace?.slug) {
    t1 = pathname === `/${workspace?.slug}/projects` || pathname?.includes("/projects/") || issueType === "action-item" || issueType === "feedback-item";
    $[0] = issueType;
    $[1] = pathname;
    $[2] = workspace?.slug;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      name: "Projects",
      href: t0,
      current: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `/${workspace?.slug}/support`;
  const t4 = pathname === `/${workspace?.slug}/support` || issueType === "support-request";
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      name: "Support",
      href: t3,
      current: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `/${workspace?.slug}/settings`;
  let t7;
  if ($[10] !== pathname || $[11] !== workspace?.slug) {
    t7 = pathname === `/${workspace?.slug}/settings` || pathname?.includes(`/${workspace?.slug}/settings`);
    $[10] = pathname;
    $[11] = workspace?.slug;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = {
      name: "Settings",
      href: t6,
      current: t7
    };
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t5 || $[18] !== t8) {
    t9 = [t2, t5, t8];
    $[16] = t2;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let nav = t9;
  if (!isAdmin(user)) {
    let t10;
    if ($[20] !== nav) {
      t10 = nav.filter(_temp);
      $[20] = nav;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    nav = t10;
  }
  const isMobile = useMediaQuery("only screen and (max-width: 768px)");
  if (isMobile) {
    let t10;
    if ($[22] !== nav) {
      t10 = <HeaderMobile nav={nav} />;
      $[22] = nav;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    return t10;
  }
  let t10;
  if ($[24] !== nav) {
    t10 = <HeaderDesktop nav={nav} />;
    $[24] = nav;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
const DialogContext = createContext(undefined);
const useDialogState = () => {
  return useContext(DialogContext);
};
export function HeaderMobile(t0) {
  const $ = _c(40);
  const {
    nav
  } = t0;
  const containerRef = useRef(null);
  const workspace = useCurrentWorkspace();
  const user = useCurrentUser();
  let t1;
  if ($[0] !== user) {
    t1 = isSuperAdminFn(user);
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSuperAdmin = t1;
  const router = useRouter();
  const [, startTransition] = useTransition();
  const [open, setOpen] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const r = document.querySelector("html");
      r?.style?.setProperty?.("--header-height", `${containerRef.current?.clientHeight ?? 63}px`);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[4] !== open) {
    t4 = [open, setOpen];
    $[4] = open;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link unstyled={true} href="/"><Image src={logo} alt="Fluent Group" className="h-7 w-auto object-contain object-center" /></Link>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== open) {
    t6 = () => setOpen(!open);
    $[7] = open;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== open || $[10] !== t6) {
    t7 = <div ref={containerRef} className="sticky inset-x-0 top-0 z-[9999] [--animation-delay:0ms] [--animation-duration:1400ms]"><div className="mx-auto space-y-6 bg-slate-1 px-8 py-6"><div className="flex items-center justify-between gap-5">{t5}<MenuToggle open={open} onClick={t6} autoFocus={open} /></div></div></div>;
    $[9] = open;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Drawer.Overlay className="fixed inset-0 z-50 bg-slateA-4" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mx-auto mb-8 h-1.5 w-12 flex-shrink-0 rounded-full bg-slate-3" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== user) {
    t10 = user && <><div className="flex items-center gap-4 px-4"><Avatar className="h-10 w-10"><AvatarImage src={user?.avatarUrl ?? ""} alt={user?.name} /><AvatarFallback name={user?.name} size={40} /></Avatar><div className="flex flex-col"><p className="font-medium">{user.name}</p><p className="whitespace-normal break-all text-slate-10">{user.email}</p></div></div><div className="mt-4 h-px bg-slate-6" /></>;
    $[14] = user;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== nav) {
    let t12;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = item => <NavLink href={item.href} current={item.current} aria-current={item.current} key={item.href} className="py-1.5" onClick={() => setOpen(false)}>{item.name}</NavLink>;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    t11 = nav.map(t12);
    $[16] = nav;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <div className="mt-4 flex flex-col justify-stretch space-y-2 px-4" role="list">{t11}</div>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mt-4 h-px bg-slate-6" />;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== isSuperAdmin || $[23] !== workspace?.name) {
    t14 = <div className="mx-2 mt-4 px-4">{isSuperAdmin ? <WorkspaceSwitcher /> : <p>{workspace?.name}</p>}</div>;
    $[22] = isSuperAdmin;
    $[23] = workspace?.name;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== router || $[26] !== user) {
    t15 = user && <><div className="mt-4 flex flex-col justify-stretch space-y-2 px-4" role="list"><button className="relative rounded-md px-2.5 py-1.5 text-left text-slate-12 hover:bg-slate-3 hover:text-slate-12 active:bg-slate-3" onClick={() => {
          setOpen(false);
          startTransition(async () => {
            await fetch("/api/logout", {
              method: "POST"
            });
            router.push("/");
          });
        }}>Logout</button></div></>;
    $[25] = router;
    $[26] = user;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t14 || $[31] !== t15) {
    t16 = <Drawer.Portal>{t8}<Drawer.Content className="fixed bottom-0 left-0 right-0 z-50 mt-24 flex h-[calc(100%_-_var(--header-height))] flex-col bg-white py-4 shadow-lg dark:bg-slate-2">{t9}{t10}{t12}{t13}{t14}{t15}</Drawer.Content></Drawer.Portal>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16 || $[34] !== t4 || $[35] !== t7) {
    t17 = <DialogContext.Provider value={t4}>{t7}{t16}</DialogContext.Provider>;
    $[33] = t16;
    $[34] = t4;
    $[35] = t7;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== open || $[38] !== t17) {
    t18 = <Drawer.Root open={open} onOpenChange={setOpen} shouldScaleBackground={true}>{t17}</Drawer.Root>;
    $[37] = open;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}
function HeaderDesktop(t0) {
  const $ = _c(18);
  const {
    nav
  } = t0;
  const workspace = useCurrentWorkspace();
  const user = useCurrentUser();
  let t1;
  if ($[0] !== user) {
    t1 = isSuperAdminFn(user);
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSuperAdmin = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link unstyled={true} href="/"><Image src={logo} alt="Fluent Group" className="h-6 w-auto object-contain object-center" /></Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== nav) {
    t3 = nav.map(_temp2);
    $[3] = nav;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex items-center gap-10">{t2}<div className="flex flex-row items-center gap-6 max-md:hidden">{t3}</div></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isSuperAdmin || $[8] !== workspace?.name) {
    t5 = isSuperAdmin ? <WorkspaceSwitcher /> : <p>{workspace?.name}</p>;
    $[7] = isSuperAdmin;
    $[8] = workspace?.name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== user) {
    t6 = user && <UserNav user={user} />;
    $[10] = user;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex items-center gap-4 max-md:hidden">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <div className="mx-auto space-y-6 bg-slate-2 px-8 py-6"><div className="flex items-center justify-between gap-5">{t4}{t7}</div></div>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp2(item) {
  return <NavLink href={item.href} key={item.href} current={item.current} aria-current={item.current}>{item.name}</NavLink>;
}
const NavLink = t0 => {
  const $ = _c(17);
  let children;
  let className;
  let current;
  let href;
  let props;
  if ($[0] !== t0) {
    ({
      href,
      current,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = current;
    $[4] = href;
    $[5] = props;
  } else {
    children = $[1];
    className = $[2];
    current = $[3];
    href = $[4];
    props = $[5];
  }
  const t1 = !current;
  let t2;
  if ($[6] !== className || $[7] !== t1) {
    t2 = cn("relative rounded-md px-2.5 py-2 text-slate-12", {
      "hover:bg-slate-3 hover:text-slate-12 active:bg-slate-3": t1
    }, className);
    $[6] = className;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== current) {
    t3 = current && <motion.span layoutId="bubble" className="absolute inset-0 z-10 bg-slate-3 mix-blend-multiply dark:mix-blend-difference" style={{
      borderRadius: "6px"
    }} transition={{
      type: "spring",
      bounce: 0.2,
      duration: 0.6
    }} />;
    $[9] = current;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== children || $[12] !== href || $[13] !== props || $[14] !== t2 || $[15] !== t3) {
    t4 = <Link {...props} unstyled={true} href={href} className={t2}>{t3}{children}</Link>;
    $[11] = children;
    $[12] = href;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
const MenuToggle = forwardRef((t0, ref) => {
  const $ = _c(15);
  let className;
  let open;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      open,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = open;
    $[3] = props;
  } else {
    className = $[1];
    open = $[2];
    props = $[3];
  }
  const t1 = props;
  let t2;
  if ($[4] !== className) {
    t2 = cn(className, "group rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-7");
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = open ? "open" : "closed";
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.path strokeLinecap="round" strokeLinejoin="round" variants={{
      closed: {
        d: "M 3 6 L 21 6"
      },
      open: {
        d: "M 6 6 L 18 18"
      }
    }} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth={1.5} stroke="currentColor" className="z-50 h-6 w-6 text-slate-9 group-hover:text-slate-11">{t4}<motion.path strokeLinecap="round" strokeLinejoin="round" variants={{
        closed: {
          d: "M 3 18 L 21 18"
        },
        open: {
          d: "M 6 18 L 18 6"
        }
      }} /></svg>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3) {
    t6 = <motion.span initial={false} animate={t3}>{t5}</motion.span>;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== ref || $[11] !== t1 || $[12] !== t2 || $[13] !== t6) {
    t7 = <button ref={ref} {...t1} className={t2}>{t6}</button>;
    $[10] = ref;
    $[11] = t1;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
});
MenuToggle.displayName = "MenuToggle";
const UserNav = t0 => {
  const $ = _c(42);
  const {
    user
  } = t0;
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  const t1 = user?.avatarUrl ?? "";
  const t2 = user?.name;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <AvatarImage src={t1} alt={t2} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = user?.name;
  let t5;
  if ($[3] !== t4) {
    t5 = <AvatarFallback name={t4} size={32} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" className="relative h-8 w-8 rounded-full"><Avatar className="h-8 w-8">{t3}{t5}</Avatar></Button></DropdownMenuTrigger>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = user?.avatarUrl ?? "";
  const t8 = user?.name;
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <AvatarImage src={t7} alt={t8} />;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = user?.name;
  let t11;
  if ($[11] !== t10) {
    t11 = <AvatarFallback name={t10} size={112} />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t9) {
    t12 = <Avatar className="h-28 w-28">{t9}{t11}</Avatar>;
    $[13] = t11;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== user.name) {
    t13 = <p className="font-medium">{user.name}</p>;
    $[16] = user.name;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== user.email) {
    t14 = <p className="whitespace-normal break-all text-slate-10">{user.email}</p>;
    $[18] = user.email;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = user.client?.name;
  let t16;
  if ($[20] !== t15) {
    t16 = <p className="whitespace-normal break-all text-slate-10">{t15}</p>;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t13 || $[23] !== t14 || $[24] !== t16) {
    t17 = <div className="flex flex-col items-center justify-center space-y-1">{t13}{t14}{t16}</div>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t12 || $[27] !== t17) {
    t18 = <div className="grid place-items-center gap-5 px-4 py-6">{t12}{t17}</div>;
    $[26] = t12;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <TooltipProvider><Tooltip><TooltipTrigger asChild={true}><button className="flex flex-1 cursor-help items-center justify-center gap-2 px-2.5 py-3 text-slate-9" disabled={true}><Icon icon="lucide:settings" className="h-4 w-4" />Profile Settings</button></TooltipTrigger><TooltipContent>Contact one of our team to change your profile settings.</TooltipContent></Tooltip></TooltipProvider>;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== router) {
    t20 = () => startTransition(async () => {
      await fetch("/api/logout", {
        method: "POST"
      });
      router.push("/");
    });
    $[30] = router;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Icon icon="lucide:log-out" className="h-4 w-4" />;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== pending || $[34] !== t20) {
    t22 = <div className="-mx-1 -mb-1 flex items-center divide-x divide-slate-6 border-t border-slate-6 text-sm">{t19}<button className="flex flex-1 items-center justify-center gap-2 px-2.5 py-3 hover:bg-slate-4 active:bg-slate-5" disabled={pending} onClick={t20}>{t21}Log out</button></div>;
    $[33] = pending;
    $[34] = t20;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t18 || $[37] !== t22) {
    t23 = <DropdownMenuContent align="end" forceMount={true}><div className="flex min-w-72 flex-col justify-between">{t18}{t22}</div></DropdownMenuContent>;
    $[36] = t18;
    $[37] = t22;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== t23 || $[40] !== t6) {
    t24 = <DropdownMenu modal={false}>{t6}{t23}</DropdownMenu>;
    $[39] = t23;
    $[40] = t6;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  return t24;
};
function _temp(n) {
  return n.name !== "Settings";
}